import Vue from 'vue'
import VueRouter from 'vue-router'
import AffiliateSetting from '../views/AffiliateSetting.vue'
import Bank from '../views/Bank.vue'
import BankTxList from '../views/BankTxList.vue'
import BonusSetting from '../views/BonusSetting.vue'
import CashbackSetting from '../views/CashbackSetting.vue'
import DepositList from '../views/DepositList.vue'
import FixTx from '../views/FixTx.vue'
import Home from '../views/Home.vue'
import DashboardLayout from '../views/Layout/DashboardLayout.vue'
import Login from '../views/Login.vue'
import MemberInfo from '../views/MemberInfo.vue'
import MemberList from '../views/MemberList.vue'
import NewRegBonusSetting from '../views/NewRegisterBonusSetting.vue'
import SCB from '../views/SCB.vue'
import Setting from '../views/Setting.vue'
import Summary from '../views/Summary.vue'
import SummaryAffiliate from '../views/SummaryAffiliate.vue'
import SummaryBonus from '../views/SummaryBonus.vue'
import SummaryRedeem from '../views/SummaryRedeem.vue'
import SummaryCashback from '../views/SummaryCashback.vue'
import SummaryDeposit from '../views/SummaryDeposit.vue'
import SummaryRegister from '../views/SummaryRegister.vue'
import SummaryReportByMember from '../views/SummaryReportByMember.vue'
import SummaryWheel from '../views/SummaryWheel.vue'
import SummaryWithdraw from '../views/SummaryWithdraw.vue'
import UserList from '../views/UserList.vue'
import Wheel from '../views/Wheel.vue'
import Redeem from '../views/Redeem.vue'
import WithdrawList from '../views/WithdrawList.vue'
import LogList from '../views/LogList.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/login',
		name: 'Login',
		component: Login,
	},
	{
		path: '/dashboard',
		component: DashboardLayout,
		children: [{
				path: '',
				component: Home,
			},
			{
				path: 'members',
				component: MemberList,
			},
			{
				path: 'members/:id',
				component: MemberInfo,
			},
			{
				path: 'fix-tx',
				component: FixTx,
			},
			{
				path: 'users',
				component: UserList,
			},
			{
				path: 'deposit',
				component: DepositList,
			},
			{
				path: 'withdraw',
				component: WithdrawList,
			},
			{
				path: 'bank-transactions',
				component: BankTxList,
			},
			{
				path: 'promotion/bonus',
				component: BonusSetting,
			},
			{
				path: 'promotion/redeem',
				component: Redeem,
			},
			{
				path: 'promotion/cashback',
				component: CashbackSetting,
			},
			{
				path: 'promotion/affiliate',
				component: AffiliateSetting,
			},
			{
				path: 'promotion/new-reg-bonus',
				component: NewRegBonusSetting,
			},
			{
				path: 'wheel',
				component: Wheel,
			},
			{
				path: 'bank',
				component: Bank,
			},
			{
				path: 'scb',
				component: SCB,
			},
			{
				path: 'summary/deposit',
				component: SummaryDeposit,
			},
			{
				path: 'summary/withdraw',
				component: SummaryWithdraw,
			},
			{
				path: 'summary/register',
				component: SummaryRegister,
			},
			{
				path: 'summary/bonus',
				component: SummaryBonus,
			},
			{
				path: 'summary/redeem',
				component: SummaryRedeem,
			},
			{
				path: 'summary/wheel',
				component: SummaryWheel,
			},
			{
				path: 'summary/cashback',
				component: SummaryCashback,
			},
			{
				path: 'summary/affiliate',
				component: SummaryAffiliate,
			},
			{
				path: 'summary/report-by-member',
				component: SummaryReportByMember,
			},
			{
				path: 'summary',
				component: Summary,
			},
			{
				path: 'setting',
				component: Setting,
			},
			{
				path: 'log',
				component: LogList,
			},
		],
	},
	{
		path: '*',
		redirect: '/dashboard',
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

router.beforeEach((to, _, next) => {
	if (to.path !== '/login' && !localStorage.getItem('prefix')) {
		next('/login')
	} else {
		next()
	}
})

export default router